import PropTypes from 'prop-types'

export default PropTypes.arrayOf(PropTypes.shape({
  director: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape({
    original: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  })),
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  videoRatio: PropTypes.number.isRequired,
  videoUrl: PropTypes.string.isRequired,
}))



// WEBPACK FOOTER //
// ./src/workProp.js